module.exports = __webpack_public_path__ + "static/media/Promotions.60deb416.png";